import { traitCategories, traitRangesByCategory } from "config";
import { BigNumber } from "ethers";
import { Trait, TraitCategory } from "types";

export const getCategoryIndexByName = (category: TraitCategory) =>
  traitCategories.indexOf(category);

export const getCategoryNameByIndex = (index: number) => traitCategories[index];

export const validateTraitCategory = (
  tokenId: number,
  category: TraitCategory
) =>
  tokenId >= traitRangesByCategory[category][0] &&
  tokenId <= traitRangesByCategory[category][1];

export const getTraitCategory = (tokenId: number) =>
  traitCategories.find((category) => validateTraitCategory(tokenId, category))!;

export const getTraitsByCategory = (
  category: TraitCategory,
  traits: number[],
  excludeTraits?: number[]
) =>
  traits.filter(
    (tokenId) =>
      validateTraitCategory(tokenId, category) &&
      !excludeTraits?.includes(tokenId)
  ) || [];

export const decorateTraitsByCategory = (
  traits: [tokenId: number, name: string][],
  category: TraitCategory
): Trait[] =>
  traits
    .filter(([tokenId]) => validateTraitCategory(tokenId, category))
    .map(([tokenId, name]) => ({
      tokenId,
      name,
      category,
      honeyConsumptionRequirement: BigNumber.from("0"),
    }));

export const applyTraitChanges = (
  initialTraits: number[],
  newTraits: number[]
): number[] =>
  initialTraits.map((traitId, index) => {
    const category = getCategoryNameByIndex(index);
    return (
      newTraits.find((tokenId) => category === getTraitCategory(tokenId)) ||
      traitId
    );
  });
